module.exports = __webpack_public_path__ + "921bddead364de43a058b35826d8034c.png";